import StatusFilterOption from './models/StatusFilterOption';

const Constants = {
  StatusFilterOptions: [
    { label: 'Not Started', values: ['N'] },
    { label: 'Started', values: ['S'] },
    { label: 'Completed', values: ['P', 'C'] },
    { label: 'Expiring', values: ['X'] },
    { label: 'Expired', values: ['E'] }
  ] as StatusFilterOption[],
  NumberOfRecentLessons: 3
};

export default Constants;
